var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{ref:"input",style:(_vm.inputStyle),attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"size":_vm.size},on:{"on-keydown":_vm.keyEvent,"on-blur":_vm.keyBlur},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }